<template lang="pug">
.v-selection.selection(v-if="block")
	.selection__wrapper(:style="{'backgroundColor': block.color}")
		img.selection__icon(:src="selectionImage" loading="lazy" alt="")
		.selection__text(v-if="block.text") {{block.text}}
		.selection__button(v-if="block.btn"
				:class="block.btn.className || ''"
				@click.stop="openModal")
			| {{block.btn.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			block: null,
			selectionImage: '/local/assets/images/selection.png',
		};
	},

	methods: {
		dataSet(data) {
			this.block = data;
		},

		openModal() {
			controller.openModal({
				className: 'modal--md',
				component: {
					name: 'v-form',
					props: {
						dataSource: this.block.form,
						media: this.block.media,
						phones: this.block.phones,
						className: 'call-back'
					}
				}
			});
		},
	}
};
</script>